/**
 * custom-grid-switcher.js
 *
 * 機能1: デスクトップ列切替ボタン (3 / 4 / 6 列)
 * 機能2: モバイル列切替トグル (1 / 2 列)
 * 機能3: モバイル「絞り込み」ボタン → フィルタードロワーを開く
 * 機能4: モバイル並び替えセレクト → FacetFiltersForm の AJAX で商品更新
 *
 * localStorage でユーザーの列数選択を保持し、
 * フィルター AJAX 更新後も MutationObserver で再適用する。
 */

(function () {
  const STORAGE_DESKTOP = 'cpg-desktop-cols';
  const STORAGE_MOBILE  = 'cpg-mobile-cols';

  /* ── ユーティリティ ───────────────────────────── */

  function getGrid() {
    return document.getElementById('product-grid');
  }

  /** デスクトップ列クラスを差し替える */
  function applyDesktopCols(cols) {
    const grid = getGrid();
    if (!grid) return;
    grid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop', 'grid--6-col-desktop');
    grid.classList.add('grid--' + cols + '-col-desktop');

    /* 6列モード専用クラス（custom-grid-image-only）を各アイテムへ付与 */
    grid.querySelectorAll('.grid__item').forEach(function (item) {
      item.classList.toggle('custom-grid-image-only', cols === '6');
    });
  }

  /** モバイル列クラスを差し替える */
  function applyMobileCols(cols) {
    const grid = getGrid();
    if (!grid) return;
    grid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
    grid.classList.add('grid--' + cols + '-col-tablet-down');
  }

  /** デスクトップボタンのアクティブ状態を更新 */
  function updateDesktopButtons(cols) {
    document.querySelectorAll('[data-cols]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.cols === cols);
      btn.setAttribute('aria-pressed', btn.dataset.cols === cols ? 'true' : 'false');
    });
  }

  /** モバイルボタンのアクティブ状態を更新 */
  function updateMobileButtons(cols) {
    document.querySelectorAll('[data-mobile-cols]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.mobileCols === cols);
      btn.setAttribute('aria-pressed', btn.dataset.mobileCols === cols ? 'true' : 'false');
    });
  }

  /* ── 初期値の適用 ────────────────────────────── */

  const desktopSwitcher = document.getElementById('CPGDesktopSwitcher');
  const mobileSwitcher  = document.getElementById('CPGMobileSwitcher');

  const defaultDesktop = desktopSwitcher ? desktopSwitcher.dataset.default || '4' : '4';
  const defaultMobile  = mobileSwitcher  ? mobileSwitcher.dataset.default  || '2' : '2';

  const savedDesktop = localStorage.getItem(STORAGE_DESKTOP) || defaultDesktop;
  const savedMobile  = localStorage.getItem(STORAGE_MOBILE)  || defaultMobile;

  applyDesktopCols(savedDesktop);
  applyMobileCols(savedMobile);
  updateDesktopButtons(savedDesktop);
  updateMobileButtons(savedMobile);

  /* ── デスクトップ列切替ボタン ────────────────── */

  document.querySelectorAll('[data-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const cols = this.dataset.cols;
      localStorage.setItem(STORAGE_DESKTOP, cols);
      applyDesktopCols(cols);
      updateDesktopButtons(cols);
    });
  });

  /* ── モバイル列切替ボタン ────────────────────── */

  document.querySelectorAll('[data-mobile-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const cols = this.dataset.mobileCols;
      localStorage.setItem(STORAGE_MOBILE, cols);
      applyMobileCols(cols);
      updateMobileButtons(cols);
    });
  });

  /* ── AJAX フィルター更新後の列クラス再適用 ──── */
  /*
   * custom-facets.js は #ProductGridContainer の innerHTML を丸ごと差し替えるため、
   * #product-grid の classList がサーバーのデフォルト値にリセットされる。
   * MutationObserver でその変化を検知し、保存済みの列数を再適用する。
   */
  var container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(function () {
      var d = localStorage.getItem(STORAGE_DESKTOP) || defaultDesktop;
      var m = localStorage.getItem(STORAGE_MOBILE)  || defaultMobile;
      applyDesktopCols(d);
      applyMobileCols(m);
      updateDesktopButtons(d);
      updateMobileButtons(m);
    }).observe(container, { childList: true });
  }

  /* ── モバイル「絞り込み」ボタン ─────────────── */
  /*
   * custom-facets.liquid がレンダリングするモバイルドロワー
   * (.mobile-facets__open-wrapper) の summary をプログラム的にクリックする。
   */
  var mobileFilterBtn = document.getElementById('CPGMobileFilterBtn');
  if (mobileFilterBtn) {
    mobileFilterBtn.addEventListener('click', function () {
      var openBtn = document.querySelector('.mobile-facets__open-wrapper');
      if (openBtn) openBtn.click();
    });
  }

  /* ── モバイル並び替えセレクト ────────────────── */
  /*
   * current URL の search params を読み取り sort_by だけ差し替えて
   * FacetFiltersForm.renderPage() を呼ぶ → フィルター状態を保ちつつ AJAX ソート。
   * FacetFiltersForm は custom-facets.js で定義（defer 順により先に実行済み）。
   */
  var mobileSortSelect = document.getElementById('SortByMobileToolbar');
  if (mobileSortSelect) {
    mobileSortSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        FacetFiltersForm.renderPage(params.toString());
      } else {
        /* フォールバック: ページ遷移でソート */
        window.location.search = params.toString();
      }
    });
  }
})();
